module.exports = __webpack_public_path__ + "img/atom-01.515ea0a1.svg";